import { Stack, StackProps, Typography } from '@mui/material';

const C_ASTERISK = '*';

type Props = {
  lines: string[];
  containerProps?: StackProps;
};

export function Asterisk(props: Props) {
  const lines = props.lines
    .map((it) => fmt(it))
    .filter((it) => it.length > 0)
    .map((it, i) => (
      <Typography key={i} variant="bodyS" color="textSecondary">
        {it}
      </Typography>
    ));

  if (lines.length === 0) {
    return null;
  }

  return (
    <Stack gap="0.5rem" {...props.containerProps}>
      {lines}
    </Stack>
  );
}

function fmt(text: string): string {
  if (!text) {
    return '';
  }

  let str = text;

  if (str[0] === C_ASTERISK) {
    str = str.slice(1);
  }

  return `${C_ASTERISK} ${str.trim()}`;
}
